// src/components/bsm/PositionCalculator.js
import React from 'react';
import { LightbulbIcon } from './BsmIcons';

export default function PositionCalculator({
  calcData,
  setCalcData,
  riskAmount,
  positionShares,
  totalPositionValue,
  targetPrice1To25,
  targetProfit,
  isStandalone = false,
}) {
  return (
    <div className={isStandalone ? "terminal-calc-standalone-view" : "desk-risk-col"}>
      <div className="risk-desk-header">
        <span className="risk-badge">DISCIPLINE RULE ≤ 2%</span>
        <h4>Trade Risk Calculator</h4>
      </div>

      <div className="risk-inputs-stack">
        <div className="risk-input-group">
          <label htmlFor="input-capital">Total Account Capital (₹)</label>
          <input
            id="input-capital"
            type="number"
            value={calcData.capital}
            onChange={(e) => setCalcData((prev) => ({ ...prev, capital: Math.max(0, +e.target.value) }))}
          />
        </div>

        <div className="risk-input-group">
          <label htmlFor="input-risk-percent">Risk Per Trade (% of Capital)</label>
          <input
            id="input-risk-percent"
            type="number"
            step="0.5"
            min="0.5"
            max="10"
            value={calcData.riskPercent}
            onChange={(e) => setCalcData((prev) => ({ ...prev, riskPercent: Math.max(0.1, +e.target.value) }))}
          />
        </div>

        <div className="risk-input-row">
          <div className="risk-input-group">
            <label htmlFor="input-entry-price">Entry Price (₹)</label>
            <input
              id="input-entry-price"
              type="number"
              value={calcData.entryPrice}
              onChange={(e) => setCalcData((prev) => ({ ...prev, entryPrice: Math.max(0.05, +e.target.value) }))}
            />
          </div>
          <div className="risk-input-group">
            <label htmlFor="input-stop-loss">Stop-Loss (₹)</label>
            <input
              id="input-stop-loss"
              type="number"
              value={calcData.stopLoss}
              onChange={(e) => setCalcData((prev) => ({ ...prev, stopLoss: Math.max(0, +e.target.value) }))}
            />
          </div>
        </div>
      </div>

      <div className="risk-outputs-stack">
        <div className="output-row">
          <span>Max Capital at Risk:</span>
          <strong className="red">₹{(riskAmount || 0).toLocaleString('en-IN', { maximumFractionDigits: 0 })}</strong>
        </div>
        <div className="output-row">
          <span>Allowed Shares:</span>
          <strong className="emerald">{(positionShares || 0).toLocaleString('en-IN')} Units</strong>
        </div>
        <div className="output-row">
          <span>Total Position Value:</span>
          <strong className="white">₹{(totalPositionValue || 0).toLocaleString('en-IN', { maximumFractionDigits: 0 })}</strong>
        </div>
        <div className="output-row highlighted">
          <span>1:2.5 Target Profit:</span>
          <strong className="gold">₹{(targetPrice1To25 || 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} (+₹{(targetProfit || 0).toLocaleString('en-IN')})</strong>
        </div>
      </div>

      <div className="risk-guidance-note">
        <LightbulbIcon width={14} height={14} />
        <span>Professional traders never enter a position before calculating the exact invalidation point and share quantity.</span>
      </div>
    </div>
  );
}
